export const VIDEO_SESSION_ACTIVE = 'video-session-active';
export const VIDEO_MESSAGING_UNREAD_EVENT = 'VideoMessagingUnread';
export type VideoOverlaySizing = 'compact' | 'sidebar' | 'fullscreen';
export const AINotesLabel = 'AI notes';
